import {airportCodeMap} from "@/config/airportCodeMap"

export default {
    reserveClick: ({commit, getters, state, dispatch}) => {
        const overwrite = state.transportationSelected && (state.flightOrigin === airportCodeMap.get("None") || !state.flightOrigin);
        dispatch("selectDefaultFlightOrigin", overwrite) // Select a default flight origin if transport is selected and no origin
        if (!getters.isFewerParticipantsThanSelectedMaxCapacity) {
            commit(
                "setErrorMessageOpen",
                'errorMessages_notEnoughAdults'
            )
        } else {
            window.location.href = getters.bookingProcessURL
        }
    },
}